import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import React__default, { forwardRef } from 'react';
import BaseTooltip from '@mui/material/Tooltip';
import { mergeWithTwcn } from '@lyearn/style';
import { popperStyles } from './styles.js';

var _excluded = ["classes", "placement", "variant"];
var DEFAULT_CLASSES = {
  arrow: 'text-bg-highlight before:ring-1 before:ring-text-info',
  popper: popperStyles,
  tooltip: "rounded-8 px-12 py-8 bg-bg-highlight body-short-03 text-text-white max-w-[25.6rem] ring-1 ring-text-info"
};
var POPOVER_CLASSES = {
  tooltip: "rounded px-12 py-8 bg-bg-primary body-short-03 text-text-primary shadow-02 border border-border"
};
var Tooltip = /*#__PURE__*/forwardRef(function (props, ref) {
  var classesProp = props.classes,
    _props$placement = props.placement,
    placement = _props$placement === void 0 ? 'top' : _props$placement,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'default' : _props$variant,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var isDefaultVariant = variant === 'default';
  var classes = mergeWithTwcn(isDefaultVariant ? DEFAULT_CLASSES : POPOVER_CLASSES, classesProp);
  return /*#__PURE__*/React__default.createElement(BaseTooltip, _extends({
    ref: ref,
    arrow: isDefaultVariant,
    classes: classes,
    enterDelay: 400,
    placement: placement
  }, rest));
});

export { Tooltip as default };
//# sourceMappingURL=Tooltip.js.map
